import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        user_login: {
            isAuthorize: false,
            username: "",
        },
        isShowEditEventDetails: false,
        //filteredDateSelection:'2021-11-01T00:00:00',
        filteredDateSelection:{
            selFilterStart: '',
            selFilterEnd: ''
            //selFilterStart:'2021-11-01T00:00:00',
            //selFilterEnd:'2021-11-01T23:59:59'
        },
        table_list: [
            {
                name:'Pending List',
                max_columns: 2,
            },
            {
                name:'Approval List',
                max_columns: 2,
            },
        ],
        event_list: [],
        calender_dates: [],
    },
    mutations: {
        user_login_authorize(state,data){
            state.user_login.isAuthorize = true;
            state.user_login.username = data.username;
        },
        user_empty(state){
            state.user_login.isAuthorize = false;
            state.user_login.username = "";
        },
        showEditEventDetails(state){
            state.isShowEditEventDetails = true;
        },
        hideEditEventDetails(state){
            state.isShowEditEventDetails = false;
        },
        update_filteredDateSelection(state,data){
            state.filteredDateSelection.selFilterStart = data.start;
            state.filteredDateSelection.selFilterEnd = data.end;
        },
        update_event_list(state, list) {
            state.event_list = list;
            state.event_list = state.event_list.sort();
        },
        update_calender_dates(state, list) {
            state.calender_dates = [];
            state.calender_dates = list;
        },
    },
    actions: {
        //updateEventList({ commit }) {
        //    return fetch(`${this.$server_address}/Testing`, {
        //        method: 'GET',
        //        //body:JSON.stringify({title:"a new todo"})
        //    }).then((res) => res.json())
        //    .then(
        //        (data) => {
        //            //console.log(data);
        //            commit("update_event_list", data);
        //            //console.log("The data");
        //        } 
        //    )
        //    .catch((err)=>console.error(err))
        //},
    },
    modules: {
    }
})
